export default defineNuxtRouteMiddleware((to, _from) => {
  // Ensure this code runs only on the client side
  if (process.client) {
    const user = useSupabaseUser();

    if (!user.value) {
      // Save the redirect path to localStorage
      localStorage.setItem("redirectPath", to.fullPath);
      return navigateTo("/login");
    }
  }
});
